import User from './user';
// 日志记录埋点
window.traceLog = function(event, eventName, content = {}) {
  if (!window.logger) {
    return;
  }
  logger.push('platform', 'mc');
  logger.push('event', event);
  logger.push('eventName', eventName);
  logger.push('device', navigator.userAgent);
  logger.push('uid', User.uid());
  // logger.push("instId", User.instId());
  logger.push('url', location.href);
  logger.push('content', JSON.stringify(content));
  logger.push('env', process.env.DEPLOY_ENV || 'local');
  logger.logger();
};



// WEBPACK FOOTER //
// ./src/core/traceLog.js